import { ITermSession } from '../../../interfaces/scheduler_interfaces';
import { ITermCoursesDatasource } from '../datasources/term_courses_datasource';
import { ITermPlannedCoursesDatasource } from '../datasources/term_planned_courses_datasource';
import { ITermSectionTypesDatasource } from '../datasources/term_section_types_datasource';
import { IDefineCommand, ICommand, IQuery, IQueryMediator } from 'core-ts-types';
import { ITermSessionsDatasource } from '../datasources/term_sessions_datasource';
import * as _4 from 'lodash4';

export type GetTermCoursesCommand = (termId: ITermSession['term']) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'getTermCoursesCommand',
    (
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      QueryMediator: IQueryMediator,
      ngTermCoursesDatasource: ITermCoursesDatasource,
      ngTermPlannedCoursesDatasource: ITermPlannedCoursesDatasource,
      ngTermSectionTypesDatasource: ITermSectionTypesDatasource,
      ngTermSessionsDatasource: ITermSessionsDatasource,
      log: any
    ): ICommand => {
      return defineCommandORM(
        'getTermCoursesCommand',
        (deferred: ng.IDeferred<IQuery[]>, termId: ITermSession['term']): ng.IPromise<void> => {
          return $http({
            method: 'GET',
            url: `reg/planned_courses/term/${termId}/`
          })
            .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
              ngTermCoursesDatasource.clear().write(data.course);
              ngTermSessionsDatasource.clear().write(_4.get(data, 'session', {}));
              ngTermPlannedCoursesDatasource.clear().write(data.planned_course);
              ngTermSectionTypesDatasource.clear().write(data.section_type);

              deferred.resolve(
                QueryMediator.runQueries(
                  ngTermPlannedCoursesDatasource,
                  ngTermCoursesDatasource,
                  ngTermSectionTypesDatasource,
                  ngTermSessionsDatasource
                )
              );
            })
            .catch((e) => {
              log.issue('Failed to get courses for this term');
              deferred.reject(e);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/term_courses/commands/get_term_courses_command.ts